import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import fetch from 'isomorphic-fetch';
import { primary_s20_l87 } from '../../../shared/lib/colors';
import Button from '../../../shared/Button/Button';
import TextField from '../../../shared/FormFields/TextField';
import CheckboxContainer from '../../../shared/FormFields/CheckboxContainer';

import {
  saveAccountEmailPassword,
  checkEmailAvailabilityEdit,
} from '../../../../redux/modules/user';
import api from '../../../../api';

import { MdLockOutline, MdCheck } from 'react-icons/md';

import './DatiAccount.scss';

class DatiAccount extends Component {
  constructor(props) {
    super(props);

    this.state = {
      salvato: false,
    };
  }

  saveAccount = userData => {
    const { id, email, password, hasSubscribedToNewsletter } = userData;
    const userToSend = { email, password, hasSubscribedToNewsletter };
    this.props.saveAccountEmailPassword(id, userToSend).then(() => {
      this.setState({
        salvato: true,
      });
    });
  };

  // renderField({ input, label, type, meta: { asyncValidating, touched, error } }) {
  //   return (
  //     <div className={`form-group ${touched && error && 'error'} ${asyncValidating ? 'async-validating' : ''}`}>
  //       <input {...input} placeholder={label} type={type} className="form-control" />
  //       {touched && error && <div className="error-text">{error}</div>}
  //     </div>
  //   );
  // }

  render() {
    const user = this.props.user.data;
    const { siteName, primaryColor } = this.props;

    return (
      <div className="dati-account">
        <h3>Dati account</h3>
        <div className="row">
          <div className="col-sm-6">
            <form onSubmit={this.props.handleSubmit(this.saveAccount)}>
              <div className="form-group">
                <label htmlFor="email" className="control-label">
                  Email
                </label>
                <Field
                  name="email"
                  component={TextField}
                  type="email"
                  label={user.email}
                />
              </div>
              <div className="form-group">
                <label htmlFor="password" className="control-label">
                  Password
                </label>
                <Field
                  name="password"
                  component={TextField}
                  type="password"
                  label="Inserisci nuova password"
                />
              </div>
              <div className="form-group mb-4">
                <label htmlFor="password" className="control-label">
                  Conferma password
                </label>
                <Field
                  name="confirmPassword"
                  component={TextField}
                  type="password"
                  label="Conferma password"
                />
              </div>
              <div className="form-group">
                <CheckboxContainer>
                  <Field
                    component="input"
                    type="checkbox"
                    name="hasSubscribedToNewsletter"
                    id="hasSubscribedToNewsletter"
                  />
                  <label htmlFor="hasSubscribedToNewsletter">
                    Iscrivimi alla newsletter di {siteName}
                  </label>
                </CheckboxContainer>
              </div>
              <hr />
              <div className="btn-container">
                <Button
                  type="submit"
                  className="btn btn-primary btn-thick float-right"
                >
                  Salva modifiche
                </Button>
                {!!this.state.salvato && (
                  <span className="success">
                    <MdCheck /> Dati salvati
                  </span>
                )}
              </div>
            </form>
          </div>
          <div className="col-sm-6">
            <div
              className="lock-icon"
              style={{ color: primary_s20_l87(primaryColor) }}
            >
              <MdLockOutline />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const validate = values => {
  const errors = {};

  if (!values.email) {
    errors.email = 'Richiesto';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Indirizzo email non valido';
  }
  if (values.password && !values.confirmPassword) {
    errors.confirmPassword = 'Richiesto';
  } else if (values.confirmPassword !== values.password) {
    errors.confirmPassword = 'Le due password non coincidono';
  }

  return errors;
};

const asyncValidate = (values, dispatch, props) => {

  const { endpoint, method, headers, body } = api.checkEmailAvailabilityEdit(values.email);

  const headersWithStoreId = {
    ...headers,
    storeid: props.storeId
  }

  return fetch(endpoint, { method, headers: headersWithStoreId, body }).then(
    response => {
      if (response.ok) {
        return response.json().then(data => {
          if (!data.available) {
            throw { email: "L'indirizzo email inserito è già utilizzato" };
          }
          return Promise.resolve(true);
        });
      } else {
        throw {
          email:
            "È avvenuto un errore durante la validazione dell'indirizzo email",
        };
      }
    }
  );
};

DatiAccount = reduxForm({
  form: 'account-data',
  enableReinitialize: true,
  validate,
  asyncValidate,
  asyncBlurFields: ['email'],
})(DatiAccount);

const mapStateToProps = state => {
  const initialValues = { ...state.user.data };
  delete initialValues.billing;
  delete initialValues.shipping;

  return {
    storeId: state.store.data.storeId,
    user: state.user,
    initialValues,
    siteName: state.store.data.datiFarmacia.siteName,
    primaryColor: state.store.data.loghiTemplate.brandColor,
  };
};

export default connect(mapStateToProps, { saveAccountEmailPassword })(
  DatiAccount
);
